import { render, staticRenderFns } from "./TicketUploadFile.vue?vue&type=template&id=85bf7d3c&"
import script from "./TicketUploadFile.vue?vue&type=script&lang=js&"
export * from "./TicketUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports